import React, { useEffect, useState } from 'react'
import ContentHeader from '../Layout/ContentHeader'
import LayoutTable from '../Global/LayoutTable'
import { useMutation, useQuery } from '@apollo/client'
import { DELETE_GROUP } from '../../graphql/Catalog/ReportGroups/reportGroups'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import { useLoading } from '../../LoadingOverlay/LoadingOverlayContext'
import { GET_ALL_GROUPS_CATEGORIES } from '../../graphql/Catalog/ReportGroups/reportCategories'
import { DELETE_GROUPS_CATEGORIES_SUB, GET_ALL_GROUPS_CATEGORIES_SUB_LIST } from '../../graphql/Catalog/ReportGroups/reportSubCaterories'


const singular = 'Subcategoría de Reporte'

const ReportSubCategories = () => {
    //HOOKS:
    const { showLoading, hideLoading } = useLoading()

    //STATES:
    const [dataTable, setDataToTable] = useState([])
    const [total, setTotal] = useState(0)
    const [pagePagination, setPagePagination] = useState({
        searchQuery: null,
        limit: 10,
        offset: 0,
    })

    //MUTATIONS:
    const [deleteItem] = useMutation(DELETE_GROUPS_CATEGORIES_SUB, {
        refetchQueries: [
            {
                query: GET_ALL_GROUPS_CATEGORIES_SUB_LIST,
                variables: {
                    offset: 0,
                    limit: 10,
                    searchQuery: null,
                },
            },
        ],
    })

    //QUERYS:
    const data = useQuery(GET_ALL_GROUPS_CATEGORIES_SUB_LIST, {
        variables: { ...pagePagination },
        fetchPolicy: 'no-cache',
    })

    //USE-EFFECTS:
    useEffect(() => { 
        if (!data.loading) {
            if (data.error)
                return toastSweetAlert({
                    mode: 'error',
                    message: data.error.message,
                })

            let list = []
            data.data.getAllGroupsCategoriesSubList?.rows.map((item) => {
                return list.push({
                    id: item.id,
                    nombre: item.name,                    
                    icono: <img src={item?.GroupsCategoriesSubToFile?.url ? item?.GroupsCategoriesSubToFile?.url : item.icon} alt="icon" width="30px" height="30px" />,
                    categoria: item.GroupCategoryOfGroupsCategoriesSub?.name,
                    descripcion: item.description.substring(0, 50) + '...',
                    
                })
            })
            setDataToTable(list)
            setTotal(data.data.getAllGroupsCategoriesSubList?.count)
        }
        
    }, [data])

    //FUNCTIONS:
    const handleDelete = async (id) => {
        
        try {

            const response = await toastSweetAlert({
                mode: 'modalConfirmCancel',
                title: 'Eliminar registro',
                message: `¿Desea continuar?`,
            })
            
            if (response.isConfirmed) {
                showLoading()
                
                const result = await deleteItem({
                    variables: {
                        deleteGroupsCategoriesSubId: parseInt(id),
                    }
                })
        
                if (result) {
                    
                    await data?.refetch({
                        variables: {
                            limit: pagePagination.limit,
                            offset: pagePagination.offset,
                            searchQuery: pagePagination.searchQuery,
                        },
                    })
                    
                    toastSweetAlert({
                        mode: 'ok',
                        message: `${singular} ${id} eliminado correctamente`,
                    })
                }
            }
                        

        } catch (error) {
            return toastSweetAlert({
                mode: 'error',
                message: error.message,
            })

        } finally { 
            hideLoading()
        }
    }

    return (
        <>
            <ContentHeader
                title={`Gestor de ${singular}`}
                breadcrumb=""
                windowTitle={ `${singular}` }
            />

            <LayoutTable                
                title={`${singular}`}
                hideDetails                
                hideId
                data={dataTable}
                actionBtnErase={ (e) => handleDelete(e)}
                setPagePagination={setPagePagination}
                pagePagination={pagePagination}
                totalCount={total}
            />
        </>
    )
}
export default ReportSubCategories